import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MicroDateRangeContext = /*#__PURE__*/createContext(undefined);
export const MicroDateRangeProvider = ({
  wrapperStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    wrapperStyleOverrides
  }), [wrapperStyleOverrides]);
  return /*#__PURE__*/_jsx(MicroDateRangeContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `MicroDateRange` component.
 * Note: The context is only available when the `MicroDateRange` component is rendered as an ancestor.
 * @returns MicroDateRangeContext - The context for the `MicroDateRange` component.
 * @returns MicroDateRangeContext.wrapperStyleOverrides - CSS overrides to apply to the `Button` component.
 */
export const useMicroDateRangeContext = () => {
  const microDateRangeContext = useContext(MicroDateRangeContext);
  return microDateRangeContext;
};